type ChevronRightIconProps = React.SVGProps<SVGSVGElement>;

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6Z"
      fill="#424242"
    />
  </svg>
);
